"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdkData = exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var constants_1 = require("../../core/constants");
exports.props = withCompInfo_1.withCompInfo(['skin', 'compProps'], function (_a, carmiData) {
    var skin = _a.skin, compProps = _a.compProps;
    var transition = constants_1.legacyTransitionTypesMap[compProps.transition] || 'NoTransition';
    var hasTransition = transition !== 'NoTransition';
    var transitionDuration = compProps.transDuration * 1000;
    var autoPlayInterval = compProps.autoplayInterval * 1000 +
        (hasTransition ? transitionDuration : 0);
    return {
        skin: skin,
        items: carmiData.itemsProps,
        currentIndex: 0,
        transition: transition,
        transitionDuration: transitionDuration,
        transitionReverse: compProps.reverse,
        shouldPreserveAspectRatio: compProps.imageMode === 'flexibleHeight',
        autoPlay: compProps.autoplay,
        autoPlayInterval: autoPlayInterval,
        showNavigation: compProps.showNavigation,
        showAutoplay: compProps.showAutoplay,
        showCounter: compProps.showCounter,
        reducedMotion: false,
        imageOnClickAction: compProps.galleryImageOnClickAction,
        alignTextRight: compProps.alignText === 'right',
        imageMode: compProps.imageMode,
    };
});
exports.css = withCompInfo_1.withCompInfo(['compLayout', 'compProps'], function (_a) {
    var compLayout = _a.compLayout, compProps = _a.compProps;
    var transDuration = compProps.transDuration, imageMode = compProps.imageMode;
    return {
        height: imageMode === 'flexibleHeight' ? 'auto' : compLayout.height + "px",
        '--transition-duration': transDuration * 1000 + "ms",
        '--alpha-txt': '1',
    };
});
var imageModeToDisplayMode = {
    clipImage: 'fill',
    flexibleHeight: 'fill',
    flexibleWidthFixed: 'fit',
};
exports.sdkData = withCompInfo_1.withCompInfo(['compProps', 'compData'], function (_a) {
    var compProps = _a.compProps, compData = _a.compData;
    return {
        imageDisplayMode: imageModeToDisplayMode[compProps.imageMode],
        dataId: compData.id,
    };
});
//# sourceMappingURL=SlideShowGallery.js.map